'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';

import Image from 'next/image';

import type { IconsWithTextType } from '@eliadmin/core/src/api/general/types/general-types';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Heading } from '../../ui/heading';
import { Paragraph } from '../../ui/paragraph';

export function ProductIcons({
  icons,
  className,
}: {
  icons: IconsWithTextType[];
  className?: string;
}) {
  return (
    <div className={cn('grid w-full grid-cols-3 gap-3', className)}>
      {icons.map((icon, index) => (
        <Icon key={index} icon={icon} />
      ))}
    </div>
  );
}

function Icon({ icon }: { icon: IconsWithTextType }) {
  return (
    <div className="col-span-1 flex w-full flex-col items-center justify-center gap-3 sm:gap-4">
      <div className="flex h-12 w-12 items-center justify-center rounded-[12px] bg-secondary">
        {icon.image?.url ? (
          <Image
            src={icon.image?.url}
            alt={resolveImageAlt(icon?.image, undefined)}
            width={24}
            height={24}
            className="shrink-0"
          />
        ) : null}
      </div>
      <div className="flex w-full flex-col items-center justify-center gap-[2px] sm:gap-1">
        <Heading tag="p" styleAs="h5" title={icon.name} center />
        <Paragraph innerHtml={icon?.description} className="w-full text-center" />
      </div>
    </div>
  );
}
